const currenciesTypes = {
  CURRENCIES_REGISTERED_SET: 'CURRENCIES_REGISTERED_SET',
  CLEAR_CURRENCY_FORM_ERRORS: 'CLEAR_CURRENCY_FORM_ERRORS',
  CURRENCIES_TABLE_LOADING: 'CURRENCIES_TABLE_LOADING',
  CURRENCY_CODE_DELETE: 'CURRENCY_CODE_DELETE',
};
export default currenciesTypes;
